var mp = mp || {};

// Slider - Hero
//-----------------------------------------------------------------
mp.sliderHero = function() {
    var $slider = $('.hero__slider .slider');

    if (!$slider.length) {
        return;
    }

    $slider.slick({
        arrows: true,
        dots: false,
        speed: 1200, 
        fade: true,
        pauseOnFocus: false,
        pauseOnHover: false,
        infinite: true,
        slidesToShow: 1,
        autoplay: true,
        appendArrows: $('.hero__slider .arrows'),
        prevArrow: '<button type="button" class="slick-prev"></button',
        nextArrow: '<button type="button" class="slick-next"></button',
    });
}


// Slider - Team
//-----------------------------------------------------------------
mp.sliderTeam = function() {
    var $slider = $('.team__slider');

    if (!$slider.length) {
        return;
    }

    $slider.slick({
        arrows: true,
        dots: false,
        speed: 600, 
        pauseOnFocus: false,
        pauseOnHover: false,
        infinite: true,
        slidesToShow: 4,
        prevArrow: '<button type="button" class="slick-prev"><i class="icon-chevron-left"></i></button',
        nextArrow: '<button type="button" class="slick-next"><i class="icon-chevron-right"></i></button',
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },
        ]
    });
}




$(document).ready(function (){
    mp.sliderHero();
    mp.sliderTeam();
});